import type { SerializedStyles } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

import type { Size } from '../tag'

export const textSize: Record<Size, SerializedStyles> = {
  small: css`
    line-height: ${size[16]};
    font-size: 9px;

    ${breakpoint.up('sm')} {
      line-height: ${size[20]};
      font-size: 11px;
    }
  `,
  medium: css`
    line-height: ${size[20]};
    font-size: 11px;

    ${breakpoint.up('sm')} {
      line-height: ${size[24]};
      font-size: 13px;
    }
  `,
}

export const uppercase = css`
  text-transform: uppercase;
`
